function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M5.87947 9.48621C2.70842 9.48621 0 9.97605 0 11.9339C0 13.8933 2.6912 14.4 5.87947 14.4C9.05051 14.4 11.7589 13.9102 11.7589 11.9523C11.7589 9.99292 9.06773 9.48621 5.87947 9.48621Z",
  fill: "#939AA3"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M5.87943 7.61986C8.03913 7.61986 9.76985 5.92494 9.76985 3.80993C9.76985 1.69492 8.03913 0 5.87943 0C3.72052 0 1.98901 1.69492 1.98901 3.80993C1.98901 5.92494 3.72052 7.61986 5.87943 7.61986Z",
  fill: "#939AA3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M11.3388 3.87901C11.3388 4.95606 11.0085 5.96105 10.4292 6.79587C10.369 6.88172 10.4222 6.99748 10.5271 7.01588C10.6727 7.03964 10.8222 7.05421 10.9748 7.05727C12.4934 7.09637 13.8562 6.1389 14.2328 4.69696C14.7909 2.55742 13.1533 0.636353 11.0672 0.636353C10.841 0.636353 10.6241 0.65935 10.4128 0.701512C10.3838 0.707645 10.3525 0.721444 10.3369 0.745974C10.3165 0.777404 10.3314 0.818033 10.3517 0.844864C10.9787 1.70574 11.3388 2.75366 11.3388 3.87901Z",
  fill: "#939AA3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M15.8233 9.73555C15.5454 9.15524 14.8746 8.75738 13.8539 8.5619C13.3724 8.44692 12.0683 8.28363 10.8558 8.30663C10.8378 8.30893 10.8276 8.3212 10.8261 8.32886C10.8237 8.34113 10.8292 8.35953 10.8527 8.37256C11.4131 8.64393 13.5791 9.82447 13.3067 12.3143C13.295 12.4232 13.3834 12.5152 13.4938 12.4999C14.0269 12.4255 15.3983 12.1365 15.8233 11.2381C16.0589 10.7628 16.0589 10.2108 15.8233 9.73555Z",
  fill: "#939AA3"
});

function SvgRole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.d2924d8f.svg";
export { ForwardRef as ReactComponent };